import { type FunctionComponent, type ReactNode } from "react";
import { Tooltip, type TooltipProps } from "nvent-web/components/Tooltip";

// import style from "./HelpTip.module.scss";
import { HelpIcon } from "../HelpIcon";

interface HelpTipProps {
  direction: TooltipProps["direction"];
  inline?: boolean;
  children: ReactNode;
}

export const HelpTip: FunctionComponent<HelpTipProps> = ({
  direction,
  children,
}) => (
  <Tooltip content={children} direction={direction} arrowSize={5}>
    <HelpIcon />
  </Tooltip>
);
